import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 0px;
    & > .MuiIconButton-root {
      margin: 0px;
      padding: 0px;
    }
  `,
  message: css`
    text-align: left;
  `,
  closeIcon: css`
    color: ${colors.white};
  `,
  toastStyle: css`
    background: ${colors.midnight} !important;
    color: ${colors.platinum} !important;
    font-size: 14px;
    font-family: 'Montserrat Regular';
    margin-bottom: 100px;
    width: 95%;
    padding: 14px 16px !important;
    & > div {
      margin: 0px;
    }
  `,
};

export default styles;
